import { Union } from "../../fable-library-js.4.24.0/Types.js";
import { Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProps_5A13F3A3, Common_GenericOptions__AddProp_7BFEDA81, Common_GenericOptions_Parse_Z749EF786, Common_GenericOptions__ToReactElement_Z6A76A149, Modifier_IModifier_$reflection, Size_ISize_$reflection } from "../Common.fs.js";
import { union_type, lambda_type, unit_type, string_type, list_type, class_type } from "../../fable-library-js.4.24.0/Reflection.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.4.24.0/MapUtil.js";
import { DOMAttr } from "../../Fable.React.7.4.3/Fable.React.Props.fs.js";
import { Reflection_getCaseName } from ".././Common.fs.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Size", "Props", "CustomClass", "OnClick", "Modifiers"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Delete.Option", [], Option, () => [[["Item", Size_ISize_$reflection()]], [["Item", list_type(class_type("Fable.React.Props.IHTMLProp"))]], [["Item", string_type]], [["Item", lambda_type(class_type("Browser.Types.MouseEvent"), unit_type)]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

/**
 * Generate <a class="delete"></a>
 */
export function delete$(options, children) {
    return Common_GenericOptions__ToReactElement_Z6A76A149(Common_GenericOptions_Parse_Z749EF786(options, (result, option) => {
        switch (option.tag) {
            case 3:
                return Common_GenericOptions__AddProp_7BFEDA81(result, new DOMAttr(40, [option.fields[0]]));
            case 1:
                return Common_GenericOptions__AddProps_5A13F3A3(result, option.fields[0]);
            case 2:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddClass_Z721C83C5(result, Reflection_getCaseName(option.fields[0]));
        }
    }, "delete"), (props_1, children_1) => react.createElement("a", keyValueList(props_1, 1), ...children_1), children);
}

